export default function formFieldHelper(state, setState) {
  return function formField(name, valueFieldName='value') {
    return {
      name,
      [valueFieldName]: state[name] || "",
      onChange: (e) => {
        setState({ ...state, [name]: e.target[valueFieldName] });
      },
    };
  };
}
